(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // Check if upsell checkbox is checked
          const upsellCheckbox = document.querySelector('.upsell-checkbox');
          if (upsellCheckbox && upsellCheckbox.checked) {
            const upsellVariantId = upsellCheckbox.dataset.variantId;
            console.log('Adding upsell product:', upsellVariantId);
            
            // Add upsell product using the same FormData method
            const upsellConfig = fetchConfig('javascript');
            upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete upsellConfig.headers['Content-Type'];
            
            const upsellFormData = new FormData();
            upsellFormData.append('id', upsellVariantId);
            upsellFormData.append('quantity', '1');
            upsellFormData.append(
              'sections',
              this.cartDrawer
                .getSectionsToRender()
                .map(section => section.section)
            );
            upsellFormData.append('sections_url', window.location.pathname);
            upsellConfig.body = upsellFormData;

            fetch(`${routes.cart_add_url}`, upsellConfig)
              .then(r => r.json())
              .then(upsellResponse => {
                console.log('Upsell added, rendering cart with both products');
                // Render cart with updated response that includes both products
                this.cartDrawer.renderContents(upsellResponse);
              })
              .catch(err => {
                console.error('Error adding upsell:', err);
                // If upsell fails, still show cart with main product
                this.cartDrawer.renderContents(response);
              });
          } else {
            // No upsell, render cart normally
            this.cartDrawer.renderContents(response);
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();